require('../../modules/es7.string.pad-end');
module.exports = require('../../modules/_core').String.padEnd;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/string/pad-end.js
// module id = 275
// module chunks = 0 1 2 3 4